import { render, staticRenderFns } from "./InvitationLoginAccountOwner.vue?vue&type=template&id=5f4f816a&scoped=true&"
import script from "./InvitationLoginAccountOwner.vue?vue&type=script&lang=ts&"
export * from "./InvitationLoginAccountOwner.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationLoginAccountOwner.vue?vue&type=style&index=0&id=5f4f816a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f816a",
  null
  
)

export default component.exports